
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore-ireland",
      function () {
        return require("private-next-pages/explore-ireland/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore-ireland"])
      });
    }
  